
document.addEventListener('DOMContentLoaded', function() {
  ali_stickyHeader();
}, false);

window.addEventListener( 'resize', ali_stickyHeader );
window.addEventListener( 'scroll', ali_stickyHeader, {passive: true} );
// var ali_stickyHeader_timeout;

function ali_stickyHeader() {
	try {
		// clearTimeout(ali_stickyHeader_timeout);
		// ali_stickyHeader_timeout = setTimeout( function(){
			let scroll_position = window.pageYOffset;
			let header = document.querySelector('.site-header');
			let header_height = header.clientHeight;

			if( (scroll_position > header_height && window.jp_scrollDirection === 'up') || scroll_position <= header_height ){
				header.classList.add('is--sticky');
			} else {
				header.classList.remove('is--sticky');
			}

			if( scroll_position <= header_height ){
				header.classList.add('is--at-top');
			} else {
				header.classList.remove('is--at-top');
			}

		// }, 50);


	}
	catch(error){
		console.log(error);
	}

}
